<template>
    <div style="background:#fff; margin-top:5px;margin-left:3px; "> 
        <div style="display:flex;background:#EBEEF5;line-height:35px;" >
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium" style="width:280px;" ></el-input> 
            <i class="iconfont icon-chenggong1" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:15px;"></i>
            <el-link   @click="selRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">选择</span></el-link>
        </div>
        <el-tree :data="prdData" 
                    :props="defaultProps" 
                    @node-click="handleNodeClick" 
                    node-key="id"                       
                    :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                    highlight-current
                    :filter-node-method="filterNode"
                    ref="eltree"
                    default-expand-all
                    :expand-on-click-node="false">
            <template v-slot="{node,data}">                                     
                <span v-if="data.id ==0 "  class="nodeRoot" >
                    <i class="iconfont  icon-wuliaoguanli" style="color:#409eff;font-size:16px;margin-right:5px;"></i>
                    <span class="nodeLabel" style="font-size:14px;font-weight:600;color:#409efe">{{ node.label}} </span>
                </span>                  
                <span v-else > 
                    <i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;margin-right:5px;"></i><span class="nodeLabel">{{ node.label}} 【{{data.id}} 】 </span>
                </span>
            </template>
        </el-tree>
 
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
 
    </div>
 
</template>
<script>

 
export default {
    data () {
        return {
            oper:'like',
            subcname:'',
            subcode:'',
            pcname:'',
            lastName:'',
            sortby:'',
  
            addFlag:'create',
            nodeLabel:'产品类别',
            treeid:'0',
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            textparam:'', // input 绑定值
            filterText:'',
            prdData:[] ,// 
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                idseq:'idseq',
                label: 'label'
            },
            disabled:false,
            parentno:'',
            promptWin:false,
            treeClickCount:0,
            prompt:'',
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
        }
    },
    created () {
        if (this.v_username){
  
            this.getTree( '') //初始查询表数据   
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    mounted () {   
       
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -140
        },
        scrollerHeight: function() {
            return (window.innerHeight - 140) + 'px';
        }, 
    },
    methods: { 
        //新增 
        selRec(){
            if (this.treeid==='0'){
                this.promptWin=true
                this.prompt='根结点不能选择'
            }else{
                this.$emit('child-select',this.treeid,this.nodeLabel )
            }
        },
 
        getTree() {   
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'v_mat_TYPE',p_cond:' and ( corpid=\''+this.v_corpid+'\')'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.prdData =res.result;  
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }            
            })                            
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1||data.id.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.parentid=data.parentid
            this.lastName=data.icon
            //记录点击次数
            this.treeClickCount++;
            //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
            if (this.treeClickCount >= 2) {
                return;
            }
            //计时器,计算300毫秒为单位,可自行修改
            this.timer = window.setTimeout(() => {
                if (this.treeClickCount == 1) {
                    //把次数归零
                    this.treeClickCount = 0;
                    //单击事件处理
                    //this.console('单击事件,可在此处理对应逻辑')
                    
                } else if (this.treeClickCount > 1) {
                    //把次数归零
                    this.treeClickCount = 0;
                    //双击事件 
                    //this.console('双击事件,可在此处理对应逻辑')
                    this.selRec()
                }
            }, 300);
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
     .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
